export default class InvalidPossessionChange extends Error {
    constructor() {
        super("Change of possession can only occur in the current drive!");
    }
}
